import type { AuthPractice } from "@elation/api-client/src/stitch-web/models";

import { useActor } from "@src/shared/providers/actorProvider";

export function useCurrentPractice(): AuthPractice {
  return useActor().practice;
}

export function useCanEditPractice(): boolean {
  return useActor().type === "physician";
}

export function usePracticeId(): number {
  return useActor().practice.id;
}
